<template>
  <base-content>
    <div class="row">
      <div class="col-sm-6">
        <verify-email />
        <user-relationship-manager no-border :user="user" />
      </div>
      <div class="col-sm-6">
        <user-card no-linkable-address title="Profile" :user="user" />
      </div>
      <div class="col-sm-12">
        <base-card body-class="pb-0">
          <template v-slot:header>
            <base-card-heading>Required Borrower Information</base-card-heading>
          </template>
          <div class="row">
            <div class="col-sm-12">
              <p>
                Please ensure that you have completed both the (i) Net Asset Statement and the
                (ii) Borrower Experience sections and contact your relationship manager who will
                review and either approve the details or request further information.
                Once the sections are marked as "complete" you will be able to submit loan applications
                in the section below.
              </p>
            </div>
            <div class="col-sm-6">
              <asset-statement-progress />
            </div>
            <div class="col-sm-6">
              <experience-progress />
            </div>
          </div>
        </base-card>
        <loan-applications />
      </div>
    </div>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import AssetStatementProgress from './AssetStatementProgress.vue'
import CreateProjectModal from './CreateProjectModal.vue'
import ExperienceProgress from './ExperienceProgress.vue'
import LoanApplications from './LoanApplications.vue'
import ProjectFilter from './ProjectFilter.vue'
import UserRelationshipManager from './UserRelationshipManager.vue'
import UserCard from './UserCard.vue'
import VerifyEmail from './VerifyEmail.vue'

export default {
  name: 'BorrowerDashboard',

  components: {
    AssetStatementProgress,
    CreateProjectModal,
    ExperienceProgress,
    LoanApplications,
    ProjectFilter,
    UserRelationshipManager,
    UserCard,
    VerifyEmail
  },

  computed: {
    ...mapState({
      user: store => store.core.auth.user
    })
  }
}
</script>
